import styled from '@emotion/styled';
import type { HasColumns } from '../rule';
import { formatColumns } from '../particle';

const RichTextWrapper = styled.div<{ rules: HasColumns }>`
  ${({ rules }) => rules.columns?.map(formatColumns)};
`;

export { RichTextWrapper };
